import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import { apiSubscribeCheck } from "../consts/links";
export const subscribeCheck = async (params, signal) => {
    return await baseFetch({
        url: getUrlWithSearchParams(apiSubscribeCheck, {}),
        withCredentials: true,
        method: "POST",
        params: {
            email: params?.email ?? "",
            password: params?.password ?? "",
            plan: params?.plan ?? "",
            token: params?.token ?? "",
        },
        signal,
    });
};
